/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import type {
  GetApiV1ExamClassRoomDisciplinesStatusQueryResponse,
  GetApiV1ExamClassRoomDisciplinesStatus401,
  GetApiV1ExamClassRoomDisciplinesStatus500,
} from "../../types/examEvaluationController/GetApiV1ExamClassRoomDisciplinesStatus.ts";
import { queryOptions, useQuery } from "@tanstack/react-query";
import { getApiV1ExamClassRoomDisciplinesStatus } from "../../clients/examEvaluationController/getApiV1ExamClassRoomDisciplinesStatus.ts";

export const getApiV1ExamClassRoomDisciplinesStatusQueryKey = () =>
  [{ url: "/api/v1/exam/class-room-disciplines-status" }] as const;

export type GetApiV1ExamClassRoomDisciplinesStatusQueryKey = ReturnType<
  typeof getApiV1ExamClassRoomDisciplinesStatusQueryKey
>;

export function getApiV1ExamClassRoomDisciplinesStatusQueryOptions(
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const queryKey = getApiV1ExamClassRoomDisciplinesStatusQueryKey();
  return queryOptions<
    GetApiV1ExamClassRoomDisciplinesStatusQueryResponse,
    ResponseErrorConfig<
      | GetApiV1ExamClassRoomDisciplinesStatus401
      | GetApiV1ExamClassRoomDisciplinesStatus500
    >,
    GetApiV1ExamClassRoomDisciplinesStatusQueryResponse,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      return getApiV1ExamClassRoomDisciplinesStatus({
        ...config,
        signal: config.signal ?? signal,
      });
    },
  });
}

/**
 * @description Retorna todos os status de disciplinas de turma disponíveis, ordenados por descrição, para uso em componentes de seleção ao filtrar aulas de uma prova. **(Requer Authorization para autenticação)**
 * @summary Listar status de disciplinas de turma para dropdown (Requer Authorization para autenticação)
 * {@link /api/v1/exam/class-room-disciplines-status}
 */
export function useGetApiV1ExamClassRoomDisciplinesStatus<
  TData = GetApiV1ExamClassRoomDisciplinesStatusQueryResponse,
  TQueryData = GetApiV1ExamClassRoomDisciplinesStatusQueryResponse,
  TQueryKey extends QueryKey = GetApiV1ExamClassRoomDisciplinesStatusQueryKey,
>(
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiV1ExamClassRoomDisciplinesStatusQueryResponse,
        ResponseErrorConfig<
          | GetApiV1ExamClassRoomDisciplinesStatus401
          | GetApiV1ExamClassRoomDisciplinesStatus500
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: Client };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...resolvedOptions } = queryConfig;
  const queryKey =
    resolvedOptions?.queryKey ??
    getApiV1ExamClassRoomDisciplinesStatusQueryKey();

  const query = useQuery(
    {
      ...getApiV1ExamClassRoomDisciplinesStatusQueryOptions(config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiV1ExamClassRoomDisciplinesStatus401
      | GetApiV1ExamClassRoomDisciplinesStatus500
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
